// extracted by mini-css-extract-plugin
export default {"container":"visiting-amenities_container__DEBZP"};